function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = 300;

    if (scrolled > coords) {
    goTopBtn.classList.remove('hide');
    }
    if (scrolled < coords) {
    goTopBtn.classList.add('hide');
    }
}

var goTopBtn = document.querySelector('.back-to-top');
window.addEventListener('scroll', trackScroll);
  

function scrollToTop(){
  window.scrollTo({top: 0, behavior: 'smooth'});
}
  
var bForces = document.querySelector("#shipping-estimator option[value='British Forces']");
if (bForces) {
    bForces.remove();
}

var nIreland = document.querySelector("#shipping-estimator  option[value='Northern Ireland']");
if(nIreland){
  nIreland.remove();
}